import * as React from 'react';
import { useEffect } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import TravellerForm from '../../TravellerForm';
import { TravellerTypes } from '../types';
import { useTheme } from '../../theme';
import { getTravellerName, MOBILE_MIN_WIDTH, useIsMobile } from '../../utils';
import UserCard from '../../UserCard/components/UserCard';
import MediaQuery from 'react-responsive';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useRenderers } from '../../renderProps';
import { CdnIcon } from '@shared/ui';
import { useToggleable } from '../../hooks';
import { ModalX, Header, IconButton } from '../../BaseComponents';
const Traveller = ({ type, traveller, cities, onSubmit, onDelete, expanded, handleChange, redirectToPassengersPage, disabled }) => {
    const { t } = useTranslation('Account');
    const css = useTheme('Traveller').Traveller;
    const isMobile = useIsMobile();
    const { isOpen, close, toggle, setOpen } = useToggleable(!!redirectToPassengersPage || !!expanded);
    const { TravellerForm: TravellerFormOverride = TravellerForm } = useRenderers();
    const onChange = (_, isExpanded) => {
        setOpen(isExpanded);
    };
    useEffect(() => {
        if (expanded !== isOpen) {
            setOpen(expanded);
        }
    }, [expanded]);
    useEffect(() => {
        if (expanded !== isOpen && handleChange) {
            handleChange(isOpen);
        }
    }, [isOpen]);
    const userLabel = React.useMemo(() => {
        if (type === TravellerTypes.CompanionEmpty) {
            return t('Add companion');
        }
        return getTravellerName(traveller);
    }, [type, traveller]);
    const travellerFormProps = {
        type,
        traveller: Object.assign(Object.assign({}, traveller), { documents: (traveller === null || traveller === void 0 ? void 0 : traveller.id) !== '0' ? traveller.documents : [] }),
        cities,
        onSubmit: values => onSubmit(Object.assign({}, values)),
        onDelete: () => onDelete(traveller.id)
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(MediaQuery, { minWidth: MOBILE_MIN_WIDTH },
            React.createElement(Accordion, { className: css.wrapper, classes: { root: css.accordion__root, expanded: css.expanded }, expanded: isOpen, onChange: onChange },
                React.createElement(AccordionSummary, { className: cn({ [css.header__redirect]: redirectToPassengersPage }, { [css.disabled]: disabled }, css.header), classes: { content: css.accordionSummary__content }, expandIcon: React.createElement("div", { className: css.expandIcon },
                        React.createElement(CdnIcon, { className: css.expandIcon, icon: "Arrow/Expand_more" })) },
                    React.createElement(UserCard, { profile: traveller, editText: type === TravellerTypes.PersonalDetails ? t('Edit') : null, inline: true, type: type, className: css.userCard, headerClassName: css.summary })),
                !redirectToPassengersPage && (React.createElement(AccordionDetails, { className: css.content__traveller },
                    React.createElement(TravellerFormOverride, Object.assign({}, travellerFormProps, { onClose: close })))))),
        React.createElement(MediaQuery, { maxWidth: MOBILE_MIN_WIDTH },
            React.createElement(UserCard, { profile: traveller, type: type, className: css.userCard, headerClassName: cn({ [css.disabled]: disabled }, css.summary), onClick: toggle }),
            React.createElement(ModalX, { classes: {
                    paper: css.popup__paper,
                    top_wrapper: css.popup__top_wrapper
                }, size: "fullscreen", title: React.createElement(Header, { className: css.popup__header, classes: {
                        inner: css.popup__inner,
                        leftSlot: css.popup__leftSlot,
                        centerSlot: css.popup__centerSlot
                    }, left: React.createElement(IconButton, { className: css.popup__button, onClick: close },
                        React.createElement(CdnIcon, { icon: "Arrow/Back" })), center: React.createElement("span", { className: css.popup__title }, userLabel), equalSlotsBasis: false, showEmptySlots: false }), isOpen: !disabled && isOpen, onClose: close, ignoreClose: isMobile, noPadding: true },
                React.createElement(TravellerFormOverride, Object.assign({ key: `${isOpen}` }, travellerFormProps, { onClose: close }))))));
};
export default Traveller;
